export default "__VITE_ASSET__pWDSt9z___"